import { Button, CircularProgress, IconButton } from "@mui/material";
import { MDBBtn, MDBCheckbox, MDBCol, MDBContainer, MDBInput, MDBRow } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import AuthService from "../api/AuthService";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { useDispatch, useSelector } from 'react-redux';
import { userLogin } from '../slices/userSlice';
import { useLocation, useNavigate } from "react-router-dom";
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { getOrCreateDeviceId } from "../utils/deviceId";

const LoginPage = () => {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const isLoading = useSelector((state) => state.user.isLoading);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [redirectPath, setRedirectPath] = useState("/");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const deviceId = getOrCreateDeviceId();
      const response = await AuthService.authenticate(email, password, deviceId);
      if (response.status === 200) {
        await dispatch(userLogin());
        navigate("/admin/dashboard");
      } else {
        setError("Не вдалося виконати вхід. Перевірте логін та пароль.");
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setError("Користувача не знайдено. Перевірте логін та пароль.");
      } else {
        setError(error.message || "Сталася несподівана помилка");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLoginSuccess = async (credentialResponse) => {
    try {
      const response = await AuthService.googleAuthenticate(credentialResponse.credential);
      if (response.status === 200) {
        await dispatch(userLogin());
        navigate("/admin/dashboard");
      }
    } catch (error) {
      setError("Не вдалося виконати вхід через Google.");
    }
  };

  useEffect(() => {
    if (!isLoggedIn && !isLoading) {
      setRedirectPath(location.state?.from || location.pathname || "/");
    }
  }, [isLoggedIn, isLoading, location.pathname, location.state]);

  return (
    <>
      {loading && (
        <div className="loader-overlay">
          <CircularProgress/>
        </div>
      )}
      <MDBContainer className="py-5" style={{ maxWidth: 520 }}>
        <div className="text-center mb-4">
          <h3 className="m-0">Авторизація</h3>
        </div>

        {error && (
          <div className="alert alert-danger text-center" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <MDBInput
            className="mb-3"
            type="email"
            value={email}
            id="email"
            label="Email"
            required
            name="username"
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="mb-3 position-relative">
            <MDBInput
              type={showPassword ? "text" : "password"}
              value={password}
              id="password"
              label="Пароль"
              required
              name="password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <IconButton
              size="small"
              onClick={() => setShowPassword(!showPassword)}
              sx={{
                position: "absolute",
                top: "50%",
                right: 8,
                transform: "translateY(-50%)",
                cursor: "pointer"
              }}
            >
              {showPassword ? <VisibilityOff fontSize="small"/> : <Visibility fontSize="small"/>}
            </IconButton>
          </div>

          <MDBRow className="mb-3">
            <MDBCol>
              <MDBCheckbox id="remember" label="Запам'ятати мене"/>
            </MDBCol>
            <MDBCol className="d-flex justify-content-end align-items-center">
              <Button
                type="button"
                className="btn btn-link p-0 m-0 align-baseline"
                onClick={() => {/* TODO: forgot password navigation */
                }}
                style={{ textTransform: 'none' }}
              >
                Забули пароль?
              </Button>
            </MDBCol>
          </MDBRow>

          <MDBBtn type="submit" className="mb-3 submit-button" block>
            Увійти
          </MDBBtn>

          {(process.env.REACT_APP_ENV === "prod" && (
            <div className="mb-2 d-flex justify-content-center">
              <GoogleOAuthProvider clientId={process.env.REACT_APP_OAUTH_CLIENT_ID}>
                <GoogleLogin
                  onSuccess={handleGoogleLoginSuccess}
                  onError={() => setError("Не вдалося виконати вхід через Google.")}
                />
              </GoogleOAuthProvider>
            </div>
          ))}
        </form>
      </MDBContainer>
    </>
  );
};

export default LoginPage;
